export const SCREEN_SHARE_ANNOTATIONS_ID = 'screenShareAnnotations';
export const SCREEN_SHARE_FABRIC_OBJECT_SERIALIZATION_PRECISION = 8;

export const isScreenShareAnnotationsSpaceID = (spaceId: string): boolean =>
  spaceId.includes(SCREEN_SHARE_ANNOTATIONS_ID);
